import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { navLink } from "../../utils/i18nRoutes";

export default function Footer() {
  const { t, i18n } = useTranslation("common");
  const currentLang = i18n.language;

  const getNavLink = (path: string) => navLink(currentLang as any, path);

  return (
    <footer className="bg-[#0B2340] text-white py-12 sm:py-14 lg:py-16 px-4 sm:px-6 lg:px-12">
      <div className="max-w-[1200px] mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 sm:gap-12 lg:gap-20 mb-10 sm:mb-12">
          {/* Brand */}
          <div>
            <p className="text-base sm:text-lg font-semibold text-white mb-4">
              {t("footer.description")}
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="text-base sm:text-lg font-semibold mb-4">
              {t("footer.quickLinks")}
            </h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to={getNavLink("/")}
                  className="text-sm sm:text-base text-white/70 hover:text-white transition-colors cursor-pointer inline-block"
                >
                  {t("nav.home")}
                </Link>
              </li>
              <li>
                <Link
                  to={getNavLink("/servicios")}
                  className="text-sm sm:text-base text-white/70 hover:text-white transition-colors cursor-pointer inline-block"
                >
                  {t("nav.services")}
                </Link>
              </li>
              <li>
                <Link
                  to={getNavLink("/soluciones-a-medida")}
                  className="text-sm sm:text-base text-white/70 hover:text-white transition-colors cursor-pointer inline-block"
                >
                  {t("nav.customSolutions")}
                </Link>
              </li>
              <li>
                <Link
                  to={getNavLink("/contacto")}
                  className="text-sm sm:text-base text-white/70 hover:text-white transition-colors cursor-pointer inline-block"
                >
                  {t("nav.contact")}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact + Social */}
          <div>
            <h3 className="text-base sm:text-lg font-semibold mb-4">
              {t("footer.contact")}
            </h3>
            <ul className="space-y-3 mb-6 sm:mb-8">
              <li>
                <a
                  href="mailto:info@velxia.es"
                  className="text-sm sm:text-base text-white/70 hover:text-white transition-colors cursor-pointer inline-block break-all"
                >
                  info@velxia.es
                </a>
              </li>
              <li>
                <a
                  href="tel:694220264"
                  className="text-sm sm:text-base text-white/70 hover:text-white transition-colors cursor-pointer inline-block"
                >
                  694 220 264
                </a>
              </li>
            </ul>

            <div className="flex gap-3 sm:gap-4">
              <a
                href="https://www.facebook.com/profile.php?id=61585882574340"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="w-10 h-10 sm:w-11 sm:h-11 flex items-center justify-center bg-white/10 rounded-lg hover:bg-white/20 transition-colors cursor-pointer"
              >
                <i className="ri-facebook-fill text-xl sm:text-2xl"></i>
              </a>
              <a
                href="https://www.instagram.com/velxiaes/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="w-10 h-10 sm:w-11 sm:h-11 flex items-center justify-center bg-white/10 rounded-lg hover:bg-white/20 transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-xl sm:text-2xl"></i>
              </a>
              <a
                href="https://www.tiktok.com/@velxiaes"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="TikTok"
                className="w-10 h-10 sm:w-11 sm:h-11 flex items-center justify-center bg-white/10 rounded-lg hover:bg-white/20 transition-colors cursor-pointer"
              >
                <i className="ri-tiktok-fill text-xl sm:text-2xl"></i>
              </a>
              <a
                href="mailto:info@velxia.es"
                aria-label="Email"
                className="w-10 h-10 sm:w-11 sm:h-11 flex items-center justify-center bg-white/10 rounded-lg hover:bg-white/20 transition-colors cursor-pointer"
              >
                <i className="ri-mail-line text-xl sm:text-2xl"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-7 sm:pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4 sm:gap-5">
          <p className="text-sm sm:text-base text-white/70 text-center">
            {t("footer.rights")}
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6 text-xs sm:text-sm text-white/70">
            <Link
              to={
                currentLang === "en" ? "/en/legal/notice" : "/legal/aviso-legal"
              }
              className="hover:text-white transition-colors cursor-pointer whitespace-nowrap"
            >
              {t("footer.legalNotice")}
            </Link>

            <Link
              to={
                currentLang === "en" ? "/en/legal/privacy" : "/legal/privacidad"
              }
              className="hover:text-white transition-colors cursor-pointer whitespace-nowrap"
            >
              {t("footer.privacy")}
            </Link>
            <Link
              to={
                currentLang === "en" ? "/en/legal/cookies" : "/politica-cookies"
              }
              className="hover:text-white transition-colors cursor-pointer whitespace-nowrap"
            >
              {t("footer.cookies")}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
